exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-dsg-tsx": () => import("./../../../src/templates/dsg.tsx" /* webpackChunkName: "component---src-templates-dsg-tsx" */)
}

